type MethodVerbMap = Record<string, string>;
const methodVerbMap: MethodVerbMap = {
  GET: 'fetching',
  POST: 'creating',
  PUT: 'updating',
  PATCH: 'updating',
  DELETE: 'deleting',
};

// Utility function to check if a URL segment is purely numeric (e.g., an ID)
const isNumeric = (segment: string) => /^\d+$/.test(segment);

// Very basic singularization: remove trailing 's'
const basicSingularize = (word: string): string => {
  return word.endsWith('s') ? word.slice(0, -1) : word;
};

/**
 * Generates a brief, human-readable error message based on HTTP method and URL.
 * Example: "Error updating user"
 */
export const getBriefErrorMessage = (method: string, url: string): string => {
  const verb = methodVerbMap[method.toUpperCase()] ?? 'processing';

  const segments = url.split('/').filter(Boolean);

  if (segments.length === 0) {
    return `Error ${verb} resource`;
  }

  let resourceName = segments[segments.length - 1] ?? 'resource';

  if (isNumeric(resourceName)) {
    resourceName =
      segments.length >= 2 ? (segments[segments.length - 2] ?? 'resource') : 'resource';
    resourceName = basicSingularize(resourceName);
  }

  return `Error ${verb} ${resourceName}`;
};
